import React from "react";
import { PagesContainer } from "../../containers";
import { BusinessReferralScreen } from "../../screens";

const ContactUsBusiness = (props) => {
  return (
    <PagesContainer {...props}>
      <BusinessReferralScreen {...props} />
    </PagesContainer>
  );
};

ContactUsBusiness.defaultProps = {};

export default ContactUsBusiness;
